/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ScreenSlashIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABK0lEQVR4nNWUvU7DMBCALfH3AMBrwCNkjUR9dwzmjoE1z8DmbgWpPFBXKkaGvgOwAI+AQFdaUGjtxMYdepKlJI6/73K+2Jhti8Hg8ghQJkB825pwzu3rQ4v8AiSffYdF/rBWTn7gxLP5HMqkJQCSmxQw/AqGK3Dimd63BKmZw/fwurZ27jgKX3zB5uAaJctiF3vSimJw5KFufK7Ax8qi8OW7OQLfF54j8CnwVIFPhacIfA48IODX1G6BUKcRP68TjEvAYb5eRiuCpmn2LModEF/H4GfnF6fa56HM9UzTg9PEovfvnxOxU9GivFvkN5MbXZlDqEP+m7kG0dXhUqDXplhZSB6CHYM87YQ753YA5TFYFuRpuN/lvlNQ1/UBkDyppGi3/JVUVbW7CfgXOzkqHO5JIhgAAAAASUVORK5CYII=)
 */
export const ScreenSlashIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m2.7 22.7 20-20a1 1 0 0 0-1.4-1.4l-20 20a1 1 0 1 0 1.4 1.4ZM13.2 16a.5.5 0 0 1-.35-.85l8.3-8.3a.5.5 0 0 1 .85.36V13a3 3 0 0 1-3 3h-5.8ZM17.15 2.85a.5.5 0 0 0-.36-.85H5a3 3 0 0 0-3 3v8a3 3 0 0 0 1.85 2.77c.17.07.36.02.49-.11l12.8-12.8ZM13.5 20a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-1.5Z"
        className={colorClass}
      />
    </svg>
  );
};
